export const text = {
  MyOpinion: "My Opinion",
  Owner: "Owner",
  Feedback: "Feedback",
  CreatedAt: "Created At",
  AssignTo: "Assign To",
  MyOpinionFormupdatedsuccessfully: "My Opinion Form updated successfully!",
  AssignedTeam: "Assigned Team",
  AssignTo: "Assign To",
  Public: "Public",
  Team: "Team",
  MyOpinionForms: "My Opinion Forms",
  MyOpinionFeedbackForm: "My Opinion Feedback Form",
  AddForm: "Add Form",
  FormName: "Form Name",
  PleaseProvidetheFormName: "Please Provide the Form Name",
  AddMyOpinionForm: "Add My Opinion Form",
  Addfieldsintheform: "Add fields in the form",
  MyOpinionForm: "My Opinion Form",
  Anonymous: "Anonymous",
  MyOpinionFormDeleted: "My Opinion Form deleted successfully!",
  reactions: "Reactions",
};
